if (!customElements.get('drawer-modal')) {
  class Drawer extends HTMLElement {
    constructor() {
      super();
      this.activeId = null;
      this.isInCart = false;
    }

    deactivateHotspotButton(buttons) {
      buttons.forEach(button => {
        button.classList.remove('hotspot-button-active');
        button.classList.add('hotspot-button-inactive');
      });
    }
    
    connectedCallback() {
      window.addEventListener('click', (e) => {

        if (e.target.tagName.toLowerCase() === 'drawer-modal') {
          this.close();

          const hotspot_buttons = document.querySelectorAll('[data-hotspot-button-mobile]');
          this.deactivateHotspotButton(hotspot_buttons)

          return;
        }

        const clickedElement = e.target.closest('[data-drawer-action]');
        if (!clickedElement) return;
        
        const {
          drawerAction,
          drawerId
        } = clickedElement.dataset;
        
        switch (drawerAction) {
          case 'open':
            const template = document.querySelector(`[data-drawer-content="${drawerId}"]`);
            if (!template) return;
            
            if (template.closest('mini-cart')) this.isInCart = true;

            const direction = template.dataset?.direction || 'left';
            const modifier = template.dataset.modifier;

            const validDirections = ['left', 'right', 'bottom', 'center', 'center-bottom', 'top-right', 'full'];
            const validModifiers = ['tall'];
            if (validDirections.includes(direction)) this.classList.add(direction);
            if (validModifiers.includes(modifier)) this.classList.add(modifier);
            if (this.activeId !== drawerId) {
              this.activeId = drawerId;
              const content = template.content.cloneNode(true);
              this.replaceChildren(content);
            }
            
            this.classList.remove('!hidden');
            document.body.classList.add('overlay');
            setTimeout(() => {
              this.classList.remove('-translate-x-full', 'md:translate-x-full', '[&.right]:translate-x-full', '[&.bottom]:translate-x-0', '[&.bottom]:translate-y-full', '[&.center-bottom]:translate-x-0', '[&.center-bottom]:translate-y-full', '[&.full]:translate-x-0', '[&.full]:translate-y-full',);
            }, 10);
          break;
          case 'close':
            const close_hotspot = clickedElement.hasAttribute('data-close-hotspot');
            const persist_cart = clickedElement.dataset.persistCart === 'true';
            if (persist_cart) this.isInCart = true

            if (close_hotspot) {
              const hotspot_buttons = document.querySelectorAll('[data-hotspot-button-mobile]');
              this.deactivateHotspotButton(hotspot_buttons);
            }

            this.close();
          break;
          default: break;
        }
      });
    }

    close() {
      this.classList.add('-translate-x-full', 'md:translate-x-full', '[&.right]:translate-x-full', '[&.bottom]:translate-x-0', '[&.bottom]:translate-y-full', '[&.center-bottom]:translate-x-0', '[&.center-bottom]:translate-y-full', '[&.full]:translate-x-0', '[&.full]:translate-y-full');      
      if (!this.isInCart) document.body.classList.add('overlay-fadeout');
      setTimeout(() => {
        this.classList.add('!hidden');
        this.classList.remove('tall', 'center', 'center-bottom', 'left', 'right', 'top-right', 'full')
        if (!this.isInCart) document.body.classList.remove('overlay', 'overlay-fadeout');
        this.isInCart = false;
      }, 500);
    }

  }
  
  customElements.define('drawer-modal', Drawer);
}